import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {rgba} from 'polished';

import ContainerHeader from 'components/common/ContainerHeader';
import AppIcon from 'components/common/AppIcon/AppIcon';

import {colors, scrollStyles} from 'styles/shared';

const TravelTabContainer = styled.div`
  height: 53rem;
  overflow-y: auto;
  padding-right: 2rem;
  ${scrollStyles};
`;

const Item = styled.div`
  padding: 2.5rem 0 3rem;
  border-bottom: ${props => (props.lastItem ? null : `0.2rem solid ${rgba(colors.darkBlue_lighter, 0.3)}`)};
`;

const ItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

const DateContainer = styled.div`
  font-weight: bold;
  font-size: 1.7rem;
  line-height: 2.7rem;
  color: ${colors.darkBlue_main};
  margin-bottom: 0.5rem;
`;

const NotesContainer = styled.div`
  font-size: 1.8rem;
  line-height: 2.2rem;
  color: ${colors.darkBlue_main};
  overflow-wrap: break-word;
`;

TravelTab.propTypes = {
  data: PropTypes.array.isRequired
};

function TravelTab({data}) {
  return (
    <TravelTabContainer>
      {data.map((item, index) => {
        let isLastItem = index + 1 === data.length;

        return (
          <Item key={item.id} lastItem={isLastItem}>
            <ItemHeader>
              <ContainerHeader>{item.title}</ContainerHeader>
              <AppIcon name="grater" />
            </ItemHeader>

            <DateContainer>{item.date}</DateContainer>

            <NotesContainer dangerouslySetInnerHTML={{__html: item.latestNote}} />
          </Item>
        );
      })}
    </TravelTabContainer>
  );
}

export default TravelTab;
